import LineItemFormTab from '@/Enums/CampaignManagement/LineItemFormTab.enum';
import { IDV360TicketsLineItemForm } from '@/Interfaces/DV360Tickets/LineItem.interface';
import AudienceTargetingService from '@/Services/AudienceTargeting.service';
import { DV360_LINE_ITEM_TABS } from '@/pages/CampaignManagement/CreateCampaign/DV360TicketsLineItemForm/constants/lineItemTabs';

export const getDirtyTabs = (formData: IDV360TicketsLineItemForm) => {
  return DV360_LINE_ITEM_TABS.filter(tab => {
    switch (tab) {
      case LineItemFormTab.Basic:
        return formData.name && formData.budget;
      case LineItemFormTab.Geo:
        return formData.geoFence || formData.geo?.included?.length || formData.geo?.excluded?.length;
      case LineItemFormTab.Audience:
        return AudienceTargetingService.checkAudiencesInTargeting(formData.audiences);
      case LineItemFormTab.Daypart:
        return Object.keys(formData.daypart ?? {}).length;
      case LineItemFormTab.Creatives:
        return !!formData?.creatives?.length;
      default:
        return false;
    }
  });
};
